import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  Divider,
  IconChevron,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import { useState, type FC } from 'react';

import translations from '../.vocab';

interface PreviousApplicationLayoutProps {
  positionTitle: JSX.Element;
  bucketAndAppliedDate: JSX.Element;
  viewJobLinkAndAttachments: JSX.Element;
  applicationTimeline: JSX.Element;
  applicationId?: string;
  onExpanded?: () => void;
  titleLabel: string;
}

export const PreviousApplicationLayout: FC<PreviousApplicationLayoutProps> = ({
  positionTitle,
  bucketAndAppliedDate,
  viewJobLinkAndAttachments,
  applicationTimeline,
  applicationId,
  onExpanded,
  titleLabel,
}) => {
  const { t } = useTranslations(translations);
  const [isExpand, setIsExpand] = useState(false);

  return (
    <Box display="flex" flexDirection="column" gap="medium">
      <Box
        data-testid={`${applicationId}-previous-application-accordion`}
        aria-label={t('Previous application positionTitle', {
          positionTitle: titleLabel,
        })}
        role="button"
        aria-expanded={isExpand}
        cursor="pointer"
        width="full"
        textAlign="left"
        tabIndex={0}
        onClick={() => {
          setIsExpand((prevState) => {
            if (!prevState && onExpanded) {
              onExpanded();
            }
            return !prevState;
          });
        }}
      >
        <Columns space="none" alignY="center">
          <Column>
            <Stack space="medium">
              <Stack space="xsmall">
                {positionTitle}
                <Inline space="xsmall" alignY="center">
                  {bucketAndAppliedDate}
                </Inline>
              </Stack>
              {viewJobLinkAndAttachments}
            </Stack>
          </Column>
          <Column width="content">
            <Text size="small" tone="secondary">
              <IconChevron direction={isExpand ? 'up' : 'down'} />
            </Text>
          </Column>
        </Columns>
      </Box>
      <Box
        data-testid={`${applicationId}-previous-application-accordion-content`}
        display={isExpand ? undefined : 'none'}
        role="region"
        onClick={() => {
          setIsExpand((prevState) => {
            if (!prevState && onExpanded) {
              onExpanded();
            }
            return !prevState;
          });
        }}
      >
        {applicationTimeline}
      </Box>
      <Divider />
    </Box>
  );
};
